import { render } from "./FilePratiche.vue?vue&type=template&id=425c7c32&scoped=true"
import script from "./FilePratiche.vue?vue&type=script&lang=js"
export * from "./FilePratiche.vue?vue&type=script&lang=js"

import "./FilePratiche.vue?vue&type=style&index=0&id=425c7c32&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425c7c32"]])

export default __exports__